(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/to-array-or-null.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/to-array-or-null.js');
"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var toArrayOrNull = function toArrayOrNull(input) {
  if (!input || _typeof(input) !== 'object') {
    return null;
  }
  var result = [];
  if (_typeof(input) === 'object' && input !== null) {
    if (Array.isArray(input)) {
      result.push.apply(result, _toConsumableArray(input));
    } else {
      for (var key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
          result.push(input[key]);
        }
      }
    }
  }
  return result;
};
if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  module.exports = {
    toArrayOrNull: toArrayOrNull
  };
} else {
  svs.content.image_v2.helpers.toArrayOrNull = toArrayOrNull;
}

 })(window);